/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Interchange_PrInputs */

const en_fc_cmp_interchange_pr = /** @type {(inputs: Fc_Cmp_Interchange_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML, AAF, EDL, OMF; native .prproj`)
};

/**
* | output |
* | --- |
* | "XML, AAF, EDL, OMF; native .prproj" |
*
* @param {Fc_Cmp_Interchange_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_interchange_pr = /** @type {((inputs?: Fc_Cmp_Interchange_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Interchange_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_interchange_pr(inputs)
});
export { fc_cmp_interchange_pr as "fc.cmp.interchange.pr" }